export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
export const ALLOWED_VIDEO_TYPES = ['video/mp4'];
export const ALLOWED_ICON_TYPES = ['image/svg+xml', 'image/png'];
export const MAX_KEYWORDS_LENGTH = 500;

export const RECOMMENDED_THUMB_FILE_TYPES = 'JPEG, PNG, SVG, WEBP';

export const RECOMMENDED_ICON_FILE_TYPES = 'SVG, PNG';
